import * as React from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';

import { Container } from './Container';
import { Services } from './Services';
import { NewsCard } from './NewsCard';
import { useParams } from 'react-router';
import { ALL_NEWS_QUERY } from '../../../client/__graphql__/queries/getAllNews';
import {
  NewsType,
  NewsSearchTypes,
} from '../../../client/types/generated/types';
import { IsValidUrl } from '../../utils/helpers/url';

export const CardContainerStyle = styled.div`
  width: 100%;
  margin: 0 auto;
  margin-top: -1em;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 20px;
  text-align: center;
  grid-row-gap: 20px;
  padding: 2em 2em 2em 2em;
  background-color: ${({ theme }) => theme.colors.redwine};

  @media all and (max-width: 1150px) {
    grid-template-columns: 1fr 1fr;
  }
  
  @media all and (max-width: 750px) {
    grid-template-columns: 1fr;
    grid-row-gap: 40px;
  }
  @media all and (max-width: 630px) {
    margin-top: 2em;
    padding-left: 2em;
  }

  @media all and (max-width: 450px) {
    margin-top: 2em;
    padding: 0;
  }
`;

export const SectionStyle = styled.div`
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 20px;
  text-align: center;
  margin-bottom: 4em;

  @media all and (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }

  @media all and (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

export const SectionArticles: React.FC<{
  style?: any;
  url?: string;
  article_type?: string;
  searchType?: NewsSearchTypes;
  subdomain?: string;
  limit?: number;
  small: boolean;
}> = ({ style, url, small, article_type, searchType, subdomain, limit }) => {
  const params = useParams<{ urltag: string }>();
  const { data, error, loading } = useQuery(ALL_NEWS_QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      input: {
        urltag: url ? url : params?.urltag ? params.urltag : '',
        type: NewsType.Nybyggportal,
        category_type: article_type,
        searchType: searchType,
        published: true,
        active: 1,
        page: 0,
        limit: limit && limit > 0 ? limit : 3,
      },
    },
  });

  const GetUrl = (item: any) => {
    if (item) {
      if (IsValidUrl(item?.externalUrl)) {
        return item?.externalUrl;
      }

      if (item?.slug) {
        if (params?.urltag || item?.officetag) {
          return `/kontor/${!item?.officetag ? params?.urltag : item?.officetag
            }/${subdomain ? subdomain : 'artikkel'}/${item.slug}`;
        }
        return `/artikkel/${item.slug}`;
      }
    }

    return '';
  };

  if (small) {
    return (
      <Container style={style}>
        <SectionStyle>
          {data?.getAllNews?.list.map((item: any, index: any) => {
            return (
              <Services
                key={item.id}
                title={item.title}
                text={item.ingress}
                link={GetUrl(item)}
              />
            );
          })}
        </SectionStyle>
      </Container>
    );
  }

  return (
    <Container>
      <CardContainerStyle>
        {data?.getAllNews?.list?.map((item: any, index: any) => (
          <NewsCard
            key={item.id}
            id={item.id}
            title={item.title}
            ingress={item.ingress}
            image={item.image}
            newTab={false}
            url={GetUrl(item)}
          />
        ))}
      </CardContainerStyle>
    </Container>
  );
};
